const en = {
    characters: 'character(s)',
    tooManyCharacters: 'character(s) too many',
    toBeDetermine: 'Coming soon',
    isRequired: 'This field is required!',
    environmentDev: 'Development environment',
    environmentTest: 'Test environment',
    sendManager: 'Save & notify my manager',
    nonApplicable: 'Non applicable',
    pageTop: 'scroll back to top',
    sendManagerNoSave: 'Notify my manager',
    managerSent: 'Your manager is notifed',
    doNotNotified: "You don't have any change to notified",
    confidential: 'Confidentiel',
    appName: 'BBA Portal',
    applications: 'Applications',
    externalApp: 'External app',
    back: 'Back',
    loading: 'Loading...',
    noOptions: 'No options',
    date: 'Date',
    title: 'Title',
    client: 'Client',
    phoneNumber: 'Phone number',
    phone: 'Phone',
    typeAnswer: 'Type your answer here',
    managerAnswer: "Manager's comments",
    employeeAnswer: 'Employee comments',
    optional: 'optional',
    manage: 'Manage',
    viewHistory: 'View history',
    viewDetails: 'View details',
    saveChanges: 'Save changes',
    save: 'Save',
    saveAndClose: 'Save and close',
    createAsADraft: 'Create as a draft',
    submitToMFiles: 'Submit to MFiles',
    submitToEmail: 'Submit to email',
    submit: 'Submit',
    successfulMFiles: 'Successfully submitted to M-Files!',
    successfulEmail: 'Successfully sent email message!',
    successfulSubmit: 'Submitted successfully!',
    successfulSave: `You have successfully saved!`,
    partiallySuccessfulSubmit: 'Submitted partially successfully',
    reviewMessages: 'Please review the following messages:',
    success: 'Success',
    partialSuccess: 'Partial success',
    failed: 'Failed',
    didNotRun: 'Abandonned',
    pdf: 'PDF',
    email: 'Email',
    mFiles: 'M-Files',
    database: 'Database',
    fileStorage: 'File storage',
    confirmDelete: 'Confirm delete',
    deleteDraftWarning: 'This will permanently delete the draft',
    actionIrreversible: 'This action is irreversible.',
    deleteDraft: 'Do you wish to delete the associated draft?',
    delete: 'Delete',
    projectNotSelected: 'Project not selected',
    failedMFiles: 'Failed to submit to M-Files 😢',
    failedEmail: 'Failed to send email message 😢',
    failedSubmit: 'Failure of one or more operations 😢',
    tryAgain: 'Unfortunately an error occurred. Do you wish try again?',
    retry: 'Retry',
    drafts: 'Drafts',
    yes: 'Yes',
    no: 'No',
    ok: 'Ok',
    reset: 'Reset',
    cancel: 'Cancel',
    close: 'Close',
    clear: 'Clear',
    confirm: 'Confirm',
    add: 'Add',
    location: 'Location',
    description: 'Description',
    suggestions: 'Suggestions',
    suggestionsAndMeasures: 'Suggestions for improvements and corrective measures',
    selectAnOption: 'Select an option',
    exportToExcel: 'Export to Excel',
    filters: 'Filters',
    entries: 'Entries',
    dateCreated: 'Date created',
    type: 'Type',
    start: 'Start',
    end: 'End',
    any: 'Any',
    status: 'Status',
    edit: 'Edit',
    closed: 'Closed',
    submittedToManager: 'Submitted',
    active: 'Active',
    verifiedUser: 'Verified M-Files user',
    verifiedProject: 'Verified M-Files project',
    reportAnIssue: 'Report an issue',
    noResults: 'No results',
    newNotification: 'unread notification{0}',
    markAs: 'Mark as',
    seen: 'seen',
    unseen: 'unseen',
    confidentiality: 'Confidentiality',
    nothingNew: "There's nothing here!",
    refresh: 'Refresh',
    clearAll: 'Clear all',
    perPage: 'per page',
    subject: 'Subject',
    from: 'From',
    to: 'To',
    fromTo: 'From / to',
    about: 'About',
    createdBy: 'Created by',
    addComment: 'Comment',
    hiddenComment: 'hidden comments',
    search: 'Search',
    manager: 'Manager',
    skip: 'Skip',
    send: 'Send',
    reply: 'Reply',
    attachments: 'Attachments',
    filePermited:
        'You can attach the following files: jpg, png, docx (Word document), pdf, xlsx (Excel document), .pptx (PowerPoint) and txt.',
    badFiles: 'Please selected files that are permitted. Those files have not been attached: ',
    badFilesOrSame:
        'Check if the file(s) already exist in the list, that the size does not exceed the limit, and that the file types are allowed. The following files have not been attached:',
    deleteAnswerTitle: 'Delete answer?',
    deleteAnswerBody: 'Are you sure you want to delete this answer?',
    sessionExpired: 'Your session has expired. Please refresh the page before continuing.',
    sessionAboutToExpire:
        'Caution! Your session is about to expire. Please save your changes now to ensure that you retain your latest additions.',
    download: 'Download',
    openMeeting: `Open meeting`,
    downloadFile: 'Download file',
    showAll: 'Show all',
    showPrevious: 'Show previous',
    showLess: 'Show less',
    answer: 'Add an answer',
    lastModified: 'Last modified',
    unsavedChanges: 'You have unsaved changes, are you sure you want to leave?',
    downloadPdf: 'Download PDF',
    later: 'Later',
    none: 'None',
    firstname: 'Firstname',
    lastname: 'Lastname',
    telephone: 'Telephone',
    office: 'Office',
    openHelpLinks: 'Click to open helper links menu',
    newVersionAvailable: 'A new version of the portal is available',
    employeeDevelopmentYear: 'Evaluation Year',
    completed: 'Completed',
    name: 'Name',
    deletePart1: 'Are you sure you want to delete',
    warning: 'Warning',
    synchronize: 'Synchronize',
    hours: `Hours`,
    notApplicableShort: 'N/A',
    notification: 'Notifications',
    loadFilesError: `Downloading the document did not work. Please try again.`,
    accessDenied: `You don't have access to see these information or your session has been expired.`,
    selectYear: `Select a year`,
    meeting: {
        meetingStatus: [
            'Active',
            'Completed',
            'Abandonned',
            'Pending',
            'Submited',
            'In revision',
            'Inactive',
            'Approved',
            'Closed by default',
            'To do',
        ],
        meetingCareer: ['Active', 'Submited', 'Completed', 'Post-meeting comments', 'Closed by default', 'To do'],
    },
    sections: {
        disabledSection: 'Closed application',
        referenceYear: 'Reference years',
        mandatoryObjective: `Operational objective`,
        individualObjective: `Personalized objectives`,
        synergy: `Individual performance`,
        approbation: `Approval required`,
        subTitleApprobationOverall: `Your overall assessment meeting is over, you must now approve the data entered. If you agree with the content of this form . Press the button below!`,
        subTitleApprobationObjectif: `Your annual objective meeting is over, you must now approve the data entered. If you agree with the content of this form . Press the button below!`,
        careerJobLevel: 'RH Level',
        careerMeetingDetails: 'Career meeting date',
        previousOverallAssessement: 'Previous overall assessement meeting',
        yearOverView: 'Thoughtful review of your year at BBA',
        objectiveReview: 'Year-end review of objectives',
        parhMembers: 'HRBP my employees list',
        enddingQuestion: 'Other',
        departmentMembers: 'My other team members',
        reminder: 'Important',
        emailNotification: 'Notify me of new notifications by email for the following sections :',
        preferences: 'Account preferences ',
        personalInfo: 'Personal information',
        employeeDetails: 'Employee details',
        identifyTask: 'Identify the task',
        styleMapping: 'Styles mapping',
        MFilesFieldMapping: 'MFiles field mapping',
        thinkAboutTheTask: 'Think about the task',
        riskAssessment: 'Assess the risks',
        assessGoldenRule: 'Assess the golden rules',
        relatedProject: 'Related project',
        attachFiles: 'Attach files',
        selectDocuments: 'Select document(s)',
        confirmTaskSafety: 'Confirm task safety',
        eventType: 'Event type',
        whatHappened: 'What happened?',
        whatAreYouDoing: 'What are you doing?',
        whoIsThisFor: 'Who is this for?',
        interventionDetails: 'Intervention details',
        riskAssessmentOfChanges: 'Risk assessment of changes',
        activityManagement: 'Activity management',
        activityRegister: 'Activity log',
        hseMinutes: 'HSE Minutes',
        activityExtraProfessional: 'Non-work activity',
        activityCommittee: 'Committee activity',
        feedbacks: 'Feedback',
        receivedRequests: 'Pending requests',
        provideFeedback: 'Provide feedback',
        feedbackDetails: 'Feedback details',
        registerGuest: 'Register',
        watchVideo: 'Watch video',
        watchVideoOptional: 'Watch video (optional)',
        enterEmail: 'Enter your email',
        visitorHistory: 'Daily visitor history',
        manageNearmisses: 'Manage near-misses',
        previousFollowUps: 'Previous follow-up meetings',
        previousObjectives: `Previous annual objectifs meetings`,
        mobilisation: 'Engagement',
        bbaValues: 'BBA values',
        followUpDetails: 'Meeting details',
        establishMyObjectives: 'Establish my objectives',
        teamMembers: 'Direct report team member',
        dashboardAndMetrics: 'Dashboard and metrics',
        technicalSkills: 'Technical skills',
        peopleSkills: 'Interpersonal skills',
        developmentTracks: 'Development tracks (Short term)',
        previousCareers: 'Previous career meetings',
        careerPath: 'Career path',
        careerPathSubtitle: 'The goal is to evaluate the employee based on their responsibilities (position and roles held, if applicable) with respect to the applicable BBA criteria. Employees in managerial positions therefore place the cursor on the continuum according to their own perspective.',
        careerProgress: 'Career progress',
        introspection: 'Introspection',
        disciplineObjectives: 'Strategic objectives',
        roleObjectives: 'Role objectives',
        positionObjectives: 'Position objectives',
        objectivesType: 'Objectives type',
        objectiveDetails: 'Objective details',
        comments: 'Comments',
        importDocument: 'Import documents',
        viewingProfile: 'Viewing employee',
        covidIdentication: 'Identification',
        covidQuestionnaire: 'Questionnaire',
        covidSummary: 'Summary',
        employeeNotes: 'notes on employee (confidential Managers + HRBP)',
        covidFormList: "COVID-19 Declaration's list",
        careerDevelopmentObjective: 'Development objectives',
        introspectionRequiredQuestion: 'Questions - Required',
        introspectionOptionalQuestion: 'Additional questions (optional)',
        careerReturnOnDevelopmentActivities: 'Return on development activities for the current year',
        careerReturnOnDevelopmentActivitiesSubtitle:
            'Here is a list including several development paths that can be selected according to what he has had as a journey during the year.',
    },
    comments: {
        showing: 'Showing',
        of: 'of',
        comment: 'comment',
        comments: 'Comments',
        commentsDescription: 'Comments/description',
        enterComments: 'Enter your comments here',
    },
    notifs: {
        feedbackRequestTitle: 'Feedback requested',
        feedbackRequestBody: '{0} has requested some feedback on {1}.',
        newFeedbackTitle: 'New feedback',
        newFeedbackBody: '{0} sent you a feedback.',
        feedbackNotifyTitle: 'Feedback notice',
        feedbackNotifyBody: '{0} sent a feedback to {1}.',
        objectiveSendToManagerTitle: 'Objective employee warning',
        objectiveSendToManagerBody: '{0} warned you about his·her·theirs objectives before frozing them',
        objectiveNewCommentTitle: 'New comment',
        objectiveNewCommentBody: '{0} added a comment on an objective.',
        objectiveChangedTitle: 'Objective modified',
        objectiveChangedBody: '{0} modified the description of an objective.',
        objectiveFreezeTitle: 'Objectives frozen',
        objectiveFreezeBody: '{0} froze their objectives for the current year.',
        followUpNewCommentTitle: 'New comment',
        followUpNewCommentBody: '{0} added a comment in the follow-up meeting.',
        followUpFreezeTitle: 'Follow-up meeting frozen',
        followUpFreezeBody: '{0} froze their current follow-up meeting.',
        followUpSendToManagerTitle: 'Follow-Ups employee warning',
        followUpSendToManagerBody: '{0} warned you about his·her follow-ups before your meeting',
        careerSendToManagerTitle: 'Career employee warning',
        careerSendToManagerBody: '{0} warned you about his·her career before your meeting',
        overallAssessmentSendToManagerTitle: `Overall assessment employee warning`,
        overallAssessmentSendToManagerBody: `{0} warned you about his·her overall assessment before your meeting`,
        overallAssessmentAskRevisionTitle: `Your employee wants to review their meeting`,
        overallAssessmentAskRevision: `{0} notifies you that he·she wants to add content to his·her Global Appreciation meeting. Go to the approval section to reactivate the meeting`,
        objectiveAskRevisionTitle: `Your employee wants to review their meeting`,
        objectiveAskRevision: `{0} notifies you that he·she wants to add content to his·her Annual objective meeting. Go to the approval section to reactivate the meeting`,
        objectiveApprobationRequiredTitle: `Your approval is required.`,
        objectiveApprobationRequiredBody: `{0} approved and set your objectives. Please review them and, if you agree, approve them at the bottom of the page. Otherwise, ask for a review`,
        overallApprobationRequiredTitle: `Your approval is required.`,
        overallApprobationRequiredBody: `{0} approved and closed your Overall assessment. Please review it and, if you agree, approve it at the bottom of the page. Otherwise, ask for a review.`,
    },
    task: {
        task: 'Task',
        tasks: 'Tasks',
        newTask: 'New task',
        createTask: 'Create task',
        editTask: 'Edit task',
        enterTaskName: 'Enter task name (required)',
        controlsImplemented: 'I implemented the controls for all identified risks.',
        risksControlled: 'I can perform the task safely. To my knowledge, all the risks are controlled.',
        consultSupervisor: "I'm unsure and will consult my supervisor to identify other controls.",
        controlsToImplement: 'What controls must be implemented?',
    },
    nearmiss: {
        nearmiss: 'Near-miss',
        nearmisses: 'Near-misses',
        deleteEntry: 'Delete entry?',
        confirmDelete: 'This will permanently delete the entry.',
    },
    intervention: {
        closedSection: `The remote system intervention application is no longer accessible, 
        the risk analysis form has been modified in order to use it for remote interventions. The form is accessible via M-File.`,
        chooseTitle: 'Give your intervention a title',
        plannedDuration: 'Planned duration (in days)',
        theEmail: 'The email',
        appearsInvalid: 'appears invalid, please try again.',
        selectExistingClient: 'Select an existing client',
        orFillManually: 'or fill manually',
        projectClientRepresentative: 'Client project representative',
        problemClientRepresentative: 'Client representative in case of issues (optional)',
        interventionManager: 'Intervention manager',
        discipline: 'Discipline',
        sendToRecipients: 'Send to recipients (optional)',
        spaceSeparatedEmails: 'Enter email addresses separated by spaces',
        rememberClient: 'Remember client information',
        overwriteClientWarning: 'Will overwrite any existing client with the same name and location.',
        objectives: 'What are the objectives?',
        isPlanned: 'Was the intervention planned?',
        planned: 'Planned',
        unplanned: 'Unplanned',
        technicalAssistance: 'Technical assistance',
        planLink: 'Plan link',
        revisedByHseIntegrator: 'Revised by HSE integrator',
        periodCoveredInDays: 'Period covered in days (up to 7)',
        unfamiliarType: "I'm unfamiliar with the intervention type",
        areYourFamiliar: 'Are you familiar with the intervention type?',
        revisedBy: 'Revised by',
        systemName: 'System name (optional)',
        systemTypes: 'System type(s)',
        environments: 'Environment(s)',
        interventionLocation: 'Where is the intervention being carried out?',
        localIntervention: 'Directly at the client site',
        remoteIntervention: "Outside the client's perimeter",
        connectionUsed: 'Connection used',
        loginCredentials: 'Domain\\user',
        bbaEquipmentAllowed: 'Connection with BBA equipment allowed?',
        allocatedIP: 'Allocated IP address',
        followingClientProcess: 'Does the client already have a process to prevent the risk of a remote system intervention?',
        addRisk: 'Add risk',
        risk: 'Risk',
        criteria: 'Criteria',
        probability: 'Probability',
        gravity: 'Gravity',
        mitigationMeans: 'Means of mitigation',
        almostCertain: 'Almost certain',
        highProbability: 'High',
        averageProbability: 'Average',
        lowProbability: 'Low',
        highGravity: 'High',
        averageGravity: 'Average',
        lowGravity: 'Low',
        lowRisk: 'Low risk',
        averageRisk: 'Average risk',
        highRisk: 'High risk',
    },
    activities: {
        redirectManagementLog:'The activities related to the <u>monthly HSE management reports</u> are now <a href="https://forms.office.com/r/ik5mqtHJSf">here</a>.',
        attributableOffice: 'Accountable office',
        committeeType: 'Committee type',
        activityType: 'Activity type',
        activity: 'Activity',
        numberOfParticipants: 'Number of participants',
        activityDescription: 'Activity description',
        otherInformationOptional: 'Other information (optional)',
        addMoreDetails: 'Add more details',
        relatedDocumentsOptional: 'Presentation(s) or related document(s) (optional)',
        participants: 'Participants',
        enterParticipantName: "Enter a participant's name then click add",
        addParticipant: 'Add participant',
        noParticipant: 'No participant added',
        topicsCovered: 'Topic(s) covered',
        addActivity: 'Add activity',
        deleteActivity: 'Delete activity',
        details: 'Details',
        initiativeDescription: 'Activity/initiative description',
        formSelection: 'Form selection',
        orJoinList: 'or attach the list below',
        exportedActivities: 'ExportedActivities',
    },
    feedbacks: {
        yearReferenceSubtitle:
            'Please select a previous year from the drop-down menu below to display your feedback related to this reference year! The default is the current year!',
        criteria: 'Feedback criteria',
        error: 'Please give a corresponding value to your comment by clicking directly on the graduated axle.',
        average: 'Average',
        atLeastOneSubject: 'You need to check at least one subject',
        feedbacks: 'Feedback',
        noRecived: `Feedback has not yet been received!`,
        noSended: 'Feedback has not yet been sent.',
        noRequestRecived: "You didn't got feedback request yet",
        noRequestSended: "You didn't send any feedback request yet",
        submitConfirmTitle: 'Send the feedback?',
        submitConfirmOnlyManager: 'Your feedback will only be sent to the manager of {0}.',
        submitConfirmBothEmployees: 'Your feedback will be sent to {0} and his/her manager.',
        submitSuccessBody: 'Your feedback was successfully sent.',
        submitFeedback: 'Send feedback',
        searchFeedback: 'Search for a feedback',
        newFeedback: 'New feedback',
        newRequest: 'New feedback request',
        sendRequestTo: 'Send a feedback request to',
        onEmployee: 'On employee',
        managerOnly: 'Manager only',
        employeeCanView: 'Employee can view',
        informManagerOnly: 'Only inform manager',
        onlyShowReceived: 'Only show received',
        feedbackSent: 'Feedback sent',
        feedbackReceived: 'Feedback received',
        tooltipContextTitle: 'Context',
        tooltipContext:
            'Provide detailed context for your feedback by specifying who was involved, the project, the deliverables, the location, the moment, etc.',
        tooltipObservableFactsTitle: 'Observable facts',
        tooltipObservableFacts:
            'Provide details about how the person acted, the observable behaviour, the quality of the deliverables (do not include perceptions).',
        tooltipImpactsTitle: 'Impact of the facts on the project/operations',
        tooltipImpacts: 'Specify how the above-mentioned facts impacted the project/operations.',
        tooltipRecommendationsTitle: 'Recommendations (where applicable)',
        tooltipRecommendations:
            'Where necessary, provide the employee with suggestions on how to make the positive effect of this behaviour more visible or identify areas of improvement to better deal with the situation in the future.',
        received: 'Received',
        sent: 'Sent',
        filters: 'Filters',
        yourRelationship: 'Relationship details',
        sendingAsRole: 'Feedback issued by',
        receiveAsRole: 'Feedback received for the role of',
        sentAsRole: 'Sent as',
        receivedAsRole: 'Received as',
        cancelRequestTitle: 'Cancel request?',
        cancelRequestBody: 'The feedback request sent to {0} will be deleted. If necessary, it is possible to recreate a new one.',
        projectSelector: `<p>Client project (optional)
        <span style="font-size: 13px">
        Warning: To work, the project must exist in the M-Files Client Project vault. A green icon
            <span class='material-symbols-outlined'>verified_user</span> must appear to indicate that the project is valid.
        </span></p>`,
        employeeSelector: `<p>Employees</p>
        <p style="font-size: 13px">You can now send feedback to several people at a time.
        <b>However, the more people you select, the longer it will take</b> to process after you click Send.</p>
        <p style="font-size: 13px"><b>Maximum 10 employees</b></p>`,
    },
    followUp: {
        meetingDateRequired: "You must specify a date.",
        yearReferenceSubtitle:
            'Please select a previous year from the drop-down menu below to display your follow-ups related to this reference year! The default is the current year!',
        importantTitle: 'IMPORTANT MESSAGE – Follow-up meetings',
        importantText: `The questions included in the different sections of the form are optional. They're simply intended to guide your conversation (progress on objectives, engagement, values, etc.).`,
        importantText2: ` You only need to answer the questions you consider relevant at the time of your meeting. The main purpose of these meetings is to check in on how things are going and discuss matters that are important to you.`,
        submitSuccessBody: `Your Follow-up meeting was successfully sent to your manager and has been saved.`,
        noFollowUp: `There is no Follow-up meeting, yet!`,
        targetInformation: 'Open question',
        targetParagraph: 'Open discussion on internal/external elements that may have an impact on performance',
        enddingQuestionTitle: 'Other',
        objective: 'Review of your Objectives',
        feedback: 'Review of your Feedback',
        objectifReview: 'Take the opportunity to review your annual goals, update their level of completion and comment as needed.',
        feedbackReview:
            'Take the opportunity to review your latest feedback received (identify potential areas for improvement if applicable)',
        followUp: 'Follow-up',
        createAppointment: 'Create an outlook meeting request',
        addToOutlook: 'Add to Outlook',
        followUps: 'Follow-up meetings',
        outlookFileName: `Invitation - Follow-up meeting My Journey BBA - ([EmployeeName])`,
        followUpTitle: 'Invitation - Follow-up meeting My Journey BBA - ([EmployeeName])',
        followUpDescription: `<p>Hello,</p>
        <p>My BBA Journey is the program that allows you to assess the annual individual contribution of employees.</p>
        <p>Here is an invitation to a follow-up meeting. Elements regarding the performance criteria of [Employee] will be discussed.</p>
        <div><ul>
        <li>Evolution of annual objectives</li>   
        <li>Follow-up on feedback received</li>    
        <li>Mobilization</li>    
        <li>BBA values (respect / non-respect)</li>    
        <li>Technical skills (mastery/non-mastery)</li>    
        <li>Interpersonal skills (proficiency/non-proficiency)</li>    
        <li>Short-term development and training</li>    
        <li>Other elements having an impact on the annual contribution</li>    
        </ul>
        </div><p>During this meeting, it will be an excellent opportunity to highlight the good moves and discuss area of improvement. 
        The discussion will also focus on progress and realignment of expectations, if needed. 
        Following this meeting, a Follow-up Meeting document (RSP) will be produced in pdf and consolidated in the employee's file.</p>
        <p>For more details, go to the My Journey page by clicking 
        <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey">here</a>.
         Additionally, you can refer to the <a href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities">Time Code Chart</a>
          regarding the time allowed to the preparation and meeting time.</p>
          <p>Thank you for your cooperation and don't hesitate to consult your manager or HRBP if you have any question. Have a good day!</p>
          <p>Human Resources Department</p>`,
        submitFollowUp: 'Submit meeting',
        newFollowUp: 'New follow-up meeting',
        openTool: 'Open the tool',
        noTechnicalSkill: "You didn't add any technical skill yet.",
        noPeopleSkill: "You didn't add any interpersonal skill yet.",
        noDevelopmentTrack: "You didn't add any development track yet.",
        mobilisationDesc:
            'This section must only be filled out by employees. It contains optional questions that employees can choose to answer and that invite them to think about their own engagement at work. The answers employees choose to give will be available to their manager.',
        bbaValuesDesc:
            "These are the values that BBA promotes every day. Both employees and their manager can fill out this section by identifying facts, projects and behaviours relevant to the employee or any situation that demonstrates respect for the firm's values.",
        technicalSkillsDesc:
            "In reference to the Technical Skills Management tool developed by the Practice group, identify the relevant technical skills that deserve to be highlighted in the employee's individual performance review. This is based on the proficiency or lack of proficiency of the relevant skills. Both employees and their manager can fill out this section by identifying facts, projects and behaviours relevant to the employee or any situation that demonstrates proficiency or lack of proficiency of the technical skills.",
        peopleSkillsDesc:
            'In reference to the Soft Skills Referential tool in the My BBA Journey toolkit shown in the dropdown menu while clicking on the Add button below, the employee has demonstrated soft skill behaviours that should be highlighted in their individual performance review. This is based on the proficiency or lack of proficiency of the relevant skills. Both employees and their manager can fill out this section by identifying facts, projects and behaviours relevant to the employee or any situation that demonstrates proficiency or lack of proficiency of the soft skills.',
        developmentTracksDesc: `Concrete development action plans that will help employees improve in a task, project or behaviours they adopt in general. This should be done in the ${'short term'.toUpperCase()} to improve a situation. This may involve training, workshops, reading, coaching, mentoring, etc. For long-term development regarding career planning, please refer to the Career section. There, you can enter your interests, desired career development and all the actions you need to take to get there.`,
        previousAnswersHistory: 'Previous answers history',
        showHistory: 'Show previous answers',
        plannedDate: 'Meeting date',
        attentionOutlook: `Please check the above box to generate an invitation for an Outlook meeting right now (you can do this later too).`,
        attentionOutlook2: `Note that if the date on the Outlook meeting is changed, it will not be updated in My BBA Journey.`,
        closeFollowUp: 'Close meeting',
        peopleSkillName: 'Interpersonal skill',
        technicalSkillName: 'Technical skill',
        developmentTrackName: 'Development track',
        provideDetails: 'Please provide more details',
        deleteTechnicalSkill: 'Delete technical skill?',
        confirmDeleteTechnicalSkill: 'This will permanently delete the technical skill.',
        deletePeopleSkill: 'Delete interpersonal skill?',
        confirmDeletePeopleSkill: 'This will permanently delete the interpersonal skill.',
        deleteDevelopmentTrack: 'Delete development track?',
        confirmDeleteDevelopmentTrack: 'This will permanently delete the development track.',
        confirmFreezeTitle: 'Freeze meeting?',
        confirmFreezeBody: `This action will freeze the follow-up meeting and generate a summary document in M-Files.`,
        objectivesReminderTitle: 'Go to objectives?',
        objectivesReminderBody:
            'Your follow-up meeting is now complete. Take the opportunity to review your annual goals, update their level of completion and comment as needed.',
        answersHistory: 'Answer history',
        strength: 'Strength',
        opportunity: 'Improvement opportunity',
        submitSuccessBodySave: `Your Folow-up meeting has been saved. You now will be redirected to the home page of follow-ups!`,
        submitSuccessBodySaveManager: `Your employee's follow-up meeting has been saved. You will be redirected to your employee's follow-ups home page!`,
        followUpStatusLegendExplanation: [
            `You can enter the information for an employee performance follow-up.`,
            `The employee and their manager held the follow-up meeting.`,
            ``,
            ``,
            `The employee has notified their manager that they are ready for a follow-up meeting.`,
            '',
            '',
            '',
            'The meeting and approval process was not completed within the required time frame.',
        ],
    },
    objectives: {
        ops: `Operation`,
        tl: `Team Leader`,
        dm: `Departement manager`,
        od: `Office director`,
        opsObjectiveTarget: `Billable - Projects clients target hours`,
        opsObjectiveWeight: `Weight of billable target`,
        opsObjectiveNb: `# of objectives`,
        submitSuccessBody: `Your manager has been notified. You will be redirected to the home page.`,
        explainationTarget: `This value can only be changed by your manager.
        It will also be frozen when employee & manager approve the objectives.`,
        objectiveTarget: `Revised target hours`,
        justification: `Please justify the reason for the change to the target:`,
        warningfreezeObjectif: `The setting of objectives will be open to managers following the salary review exercise. (Mid-March)`,
        sectionClosed: 'At this time in the cycle, please see the Overall Assessment module!',
        HrFamily: 'HR group',
        qutObjectives: 'How many objectives',
        weightTooltip: 'Weight of operational objective',
        displayObjective: 'See the list of the number of objectives per HR group',
        displayWeight: 'See the weight list for your operational objective if you are a member of the operations department.',
        becauseReview: `The review request is to allow comments or files to be added to a annual objective meeting. By pressing the button a notification will be sent to your 
        will be sent to your manager to reopen the meeting.`,
        becauseReviewManager: `Because your employee asks you to reopen the annual objective meeting in order to add content.
        Or you want to change the content before both parties have approved it.`,
        warningApproval: `WARNING! The approval process will need to be restarted.`,
        approbationEmployee: `Approve your annual objectives`,
        approbationManager: `Approve your employee's objectives`,
        nbObjective: `Total objectives required`,
        nbObjectiveTitle: `Quantity of objective to be filled`,
        nbObjectiveExplaination: `Here is the number of objectives you need in relation to the HR level you have in BBA.`,
        nbObjectiveActive: `Current objective(s)`,
        soloPerformence: `Individual Performence`,
        soloPerformenceTitle: ``,
        soloPerformenceExplaination: ``,
        commentTitle: `Attention to your comment`,
        commentNotSaved: `You wrote a comment that you did not send.`,
        saveComment: `Save your comment`,
        cancelComment: `Do not send your comment`,
        noObjectives: `You don't have any objectives for this category.`,
        detail: 'Objective details',
        retroaction: 'Feedback',
        status: 'Status of the objective',
        readOnly: 'Read-only mode',
        lastjobLevel: 'Last year job level : ',
        newJobLevel: `Current year job level : `,
        managerTitle: `Manager Title : `,
        groupSize: `Size of your group: `,
        group: `Your group : `,
        roleInformation: 'Please consider that some roles can change the % of the target and other might not',
        targetParagraphSynergy: 'Information on the target that was applicable in the previous year, if applicable.',
        targetInformationSynergy: 'Previous year target',
        targetParagraphSynergyCurrent: 'Will be communicated to you in mid-March.',
        targetInformationSynergyCurrent: 'Current year target',
        targetParagraph:
            'NOTE : This target will be reached if BBA exceeds the minimum profitability threshold and if the employee meets all assigned challenges.',
        targetInformation: 'Conditional upon meeting eligibility criteria in the current year.',
        objectivesHeaders: 'Objective(s)',
        objectives: 'Annual objectives',
        objectiveText: 'Objective',
        myBbaJourney: 'My BBA journey',
        completion: 'Completion',
        weight: 'Weight',
        weightTotal: 'Total weight',
        disciplineObjectives: 'Projects related to strategic objectives',
        roleObjectives: 'Role objectives',
        positionObjectives: 'Position objectives',
        newObjective: 'New objective',
        editObjective: 'Edit objective',
        addObjective: 'Create objective',
        freezeObjectives: 'Set objectives',
        noObjectiveYet: "You didn't create any objective of this type yet.",
        freezeDateNotice: `Your ${new Date().getFullYear()} objectives were set on {0}.`,
        freezeRefused: "Your objectives weren't approved.",
        confirmFreezeTitle: 'Freeze objectives?',
        confirmFreezeBody: `This action will freeze all ${new Date().getFullYear()} objectives and initiate signature step within My BBA Journey where the employee would have to sign.`,
        refreezeSuccessTitle: 'Successfully sent to M-Files!',
        refreezeSuccessBody:
            "A new version of the PDF document was generated in M-Files and must be signed. Once signed, it'll be reassigned to your manager for approval.",
        disciplineObjectivesDetails: `Go beyond normal work performance required for daily tasks. Ambitious challenges. Compel the employee to excel. Contribute to achieving BBA's strategic objectives; Associated with the employee's participation in projects, committees and working groups as part of the Leadership program.`,
        roleObjectivesDetails: `Related to one or more organizational roles held by the employee. These objectives may be tasks that require learning or improvement for the employee's development.`,
        positionObjectivesDetails: `Normal work performance required in the employee's daily duties and job description. These objectives may be tasks that require learning or improvement for the employee's development.`,
        deleteObjective: 'Delete objective',
        confirmDeleteText: 'This action will permanently delete the objective and cannot be undone.',
        markObsoleteTitle: 'Mark as obsolete?',
        markObsoleteText:
            "You aren't allowed to delete an objective since your objectives were set. However, you can mark this objective as obsolete.",
        restoreObjective: 'Restore objective',
        confirmDeleteFileTitle: 'Remove attached file?',
        confirmDeleteFileBody: "This action will permantently remove the attachment '{0}'.",
        roles: 'Roles',
        result: 'Result',
        target: 'Target',
        pastTarget: "Last year's target",
        currentTarget: 'Current target',
        performance: 'Total performance',
        performanceSynergy: 'Total individual performance',
        saveRoles: 'Save roles',
        weightSumWarningTitle: `***Note that the overall individual performance will be communicated at the end of the year during the Overall assessment and will include the result of the Operational objective.`,
        weightSumWarning: 'Performance cannot be calculated if the sum of your objectives weights do not equal 100.',
        exportedObjectives: 'Exported objectives',
        exportAllObjectives: 'Export all objectives',
        rolesArray: [
            `CAM + > 500K$ in sales`,
            `Team leader of 5 or more employees`,
            `Integrator`,
            `Technical reference`,
            `Project manager / 500K$`,
            `> 500K$ in sales`,
        ],
        objectivesStatus: ['New', 'Obsolete', 'Modified', 'Approved', 'Draft', 'Deleted', 'Restored'],
        objectiveStatusLegendExplanation: [
            `You can enter information about annual objectives.`,
            `The meeting is now closed. Please refer to the Overall Assessment module.`,
            ``,
            `One of the signatures is missing.`,
            `The employee has notified their manager that they are ready for the Annual Objectives meeting.`,
            `The manager has reopened the meeting.`,
            ``,
            `Both parties have signed the objectives.`,
            `The meeting and approval process was not completed within the required time frame.`,
        ],
        synergyWarningDescription: `<h6 style="height:2.5rem; color: red;">***Important</h6>
        <p style="height:2.5rem; color: red;">If you see a value in this window that is equal to -1 or N/A.
         Please contact your HRBP so that we can investigate your file.</p>`,
        operationalObjectiveDescription: `<h6>***This objective will appear on employee profiles in mid-March following the salary review process.</h6>
        <p>
            Objective for a given year and applicable to all employees from operations (not applicable for Shared Services).
            This objective is <u>imposed</u> by the firm and <u>is not modifiable during the year</u> either by the employee or
            by his/her manager, in terms of description, weight assigned or even % completion.
        </p>
        <h6>
            Important to know: The employee's HR level is directly linked to the weight of the objective. This weight will therefore vary
            between 30% and 50% of the total weight.
        </h6>`,
        individualObjectiveDescription: `<p>
        To be established specifically for the employee and must be aligned with the SMARTS methodology. These may refer to
        reference to :
        </p>
        <ul>
            <li>Regular work performance.</li>
            <li>One or more operational roles.</li>
            <li>Projects or mandates on which the employee will be asked to collaborate during the year.</li>
            <li>Daily tasks. </li>
            <li>The job description. </li>
            <li>Learning and/or improvement required for the employee's development.</li>
        </ul>
        <p>
        These objectives can be modified in terms of the description, the weight assigned or the % of completion. They will be
        to evolve throughout the year (modification of the % of completion for each one according to the progress).
        </p>`,
        warningEligibilitySeptember: `<h5 style="color: red;">Important</h5>
        <p>Employees hired on or after September 1 are not eligible for the Synergy premium for the current year.</p>`,
    },
    guests: {
        visitedEmployee: 'Name of the person visited',
        associatedCompany: 'Associated company',
        company: 'Company',
        visiting: 'Visiting',
        checkedInSince: 'Checked in since',
        checkedIn: 'Checked in',
        checkedOut: 'Checked out',
        inOffice: 'In office',
        outOfOffice: 'Out of office',
        forceCheckOut: 'Force check out',
        exportedGuests: 'GuestsRegister',
        checkIn: 'Check in',
        checkOut: 'Check out',
    },
    employeeDetails: {
        username: 'Username',
        fetchError: "Couldn't retrieve profile information.",
        name: 'Name',
        email: 'Email address',
        title: 'Title',
        office: 'Office',
        fullName: 'Full name',
    },
    account: {
        account: 'My account',
        employeeNumber: 'Employee number',
        jobTitle: 'Job title',
        department: 'Department',
        officeLocation: 'Office location',
        offline: "You're currently offline",
    },
    appHeader: {
        subject: `Bug report`,
        bodyEmail: `Questions for users who report a bug in My BBA Journey%0D%0A%0D%0A
        1. Does this bug affect your profile, or rather one of your employees? If so, please provide the names of those affected as well as their employee numbers, if available.%0D%0A%0D%0A%0D%0A
        2. Please indicate the date and approximate time the bug occurred. This will make it easier for us to trace it in our logs.%0D%0A%0D%0A%0D%0A
        3. Did an error message window appear in the platform? If so, please take a screenshot of it, including the URL link, time and date.%0D%0A%0D%0A%0D%0A
        4. Describe the steps you took that led to the bug so we can reproduce it ourselves.%0D%0A%0D%0A%0D%0A`,
    },
    relatedProject: {
        project: 'Project',
        package: 'Package',
        mFilesProjectRequired: 'A valid M-Files project is required to submit this form.',
        projectNotInMFiles:
            "This project isn't in M-Files. You can still submit the form, but it won't be automatically archived. Please check your emails to manually archive the files after submission.",
        willBeArchived: 'This form will be archived automatically to M-Files.',
        noPackage: "This project doesn't contain packages. Please choose a different one.",
        willBeArchivedFeedback: `You chose a valid project. Thank you!`,
        mFilesProjectRequiredFeedback: `A valid M-Files project is required or simply don’t write anything in this section so you can submit your feedback.`,
    },
    searchEmployee: {
        employee: 'Employee',
    },
    addFiles: {
        fileName: 'Name',
        size: 'Size',
        empty: 'Nothing here',
        addFiles: 'Add files',
        fileCountLimit: "You're uploading more files that the maximum allowed of {0}.",
        fileSizeLimit: 'Your files are larger than the maximum size allowed of {0}.',
        reminder: `Add files, as needed.`,
    },
    goldenRules: {
        confirmGoldenRules: "I confirm the respect of BBA's golden rules.",
    },
    hrpSlider: {
        skipExplanation: 'You have specified that this question is not applicable.',
    },
    career: {
        identificationSectionName: 'Identification',
        pdfCreation: 'Close Career meeting & save.',
        whySendToManager: `What is the purpose of notifying your manager?`,
        becauseSendToManager: `This button is used to let your manager know that you have completed documenting your career thoughts and are ready for the meeting.`,
        submitSuccessBody: `Your Career meeting was successfully sent to your manager and has been saved.`,
        freezeSuccesBody: `By clicking on OK, the Career meeting will be set to a Post-meeting comments status and a PDF will be generated automatically. However, you can add content or comments throughout the year and generate a new PDF at the end of the year.`,
        closureSuccesBody: `By clicking OK, the Career meeting will be set to completed status and a PDF will be generated automatically. However, you will NO LONGER be able to add content or comment!`,
        closureTooltip: `From December 1 of the current year, this module will become active. By clicking on this button, the Career meeting will be set to a completed status, and a PDF will be generated automatically. However, you will NO LONGER be able to add content or comment!`,
        showManagerResult: 'Show my selection to employee',
        noCareer: `There is no Career meeting, yet!`,
        description: `The HR level is the one for the current year.`,
        description2: `It’s the level that was indicated when you received your most recent pay slip or, if applicable, when you last changed positions.`,
        jobLevel: 'Job level',
        plannedDate: 'Meeting date',
        attentionOutlook: `Please check the above box to generate an invitation for an Outlook meeting right now (you can do this later too).`,
        attentionOutlook2: `Note that if the date on the Outlook meeting is changed, it will not be updated in My BBA Journey.`,
        specify: 'Specify',
        nameActivities: 'Name the activities',
        managerLabel: 'Manager holding the meeting',
        manager: 'Manager',
        important: 'Important',
        importantNewText: `<p>To support your career development, we have reviewed and simplified the career discussion form.</p><p>It includes five sections designed to facilitate a structured and meaningful conversation with your manager.</p><p>A guide is also available on the intranet; links are provided directly within the form.</p>`,
        importantDialogText: `The questions in the form are for your consideration and are `,
        importantDialogText2: `optional`,
        importantDialogText3: `. Employees are encouraged to respond to questions that speak to them and that they wish to share information with their manager. `,
        importantDialogText4:
            'The evaluation for the employee concerned must be based on his/her current responsibilities (position, role(s), HR level).',
        iUnderstand: 'I understand',
        newCareer: 'Create a career meeting',
        scheduleMeeting: 'Schedule a Meeting',
        submitToMyManager: 'Submit to my manager',
        career: 'Career',
        legend: 'Legend',
        employee: 'Employee',
        teamLeader: 'Team leader',
        both: 'Both',
        submitConfirmTitle: 'Send career informations',
        submitConfirmBody: 'The answers are final',
        addToOutlook: 'Plan in Outlook',
        downloadPDF: 'Download PDF',
        freezeDateNotice: 'Your career introspection was frozen on {0}.',
        meetingTitle: 'Invitation - Career meeting My Journey BBA - ([EmployeeName])',
        meetingDescription: `<p>Hello,</p>
        <p>At BBA, we care about employee development. We understand how important it is for employees to feel supported and guided in their career development. So, here's an invitation to a Career meeting where you will discuss [EmployeeName]'s development.  </p>
        <p><strong>Important information about this meeting:</strong></p>
        <ul>
        <li>The <u><strong></strong>purpose</strong></u> of the Career meeting, as part of My BBA Journey, is to stimulate <u>rich and qualitative discussions</u>.</li>
        <li>The suggested questions are <strong><u>meant</u></strong> to encourage employees to think about their career prospects and development, and to <u>look inward professionally</u>.</li>
        <li><strong><u>How</u></strong> :
            <ul>
              <li><u>Employees</u> can document their professional reflections at any time, both transparently and honestly.</li>
              <li><u>Managers</u> accompany employees through their reflections and guide them in their professional development.</li>
            </ul>
        </li>
        <li><u><strong>What: Areas of thought</strong></u>
        <ul>
        <li>Interests (projects, positions, tasks, responsibilities, roles)</li>
        <li>BBA axes</li>
        <li>Appreciation of the position, current roles</li>
        <li>Future BBA projection (short, medium and long term)</li>
        <li>Interest in assignments, mobility, relocation</li>
        <li>Identification of strengths and improvement opportunities</li>
        <li>Required support / development</li>
        </ul>
        </li>
        </ul>
        <ul>
        <li><strong>Duration</strong> : About 60 minutes, depending on discussions. Please refer to the applicable charge code  <a href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities">here</a>.</li>
        <li><strong>When</strong> :
        <ul>
        <li>When it's convenient for both the manager and employee.</li>
        <li>There is no set date</li>
        <li>It simply must be held between January 1 and December 31 of the current year</li>
        <li>You can combine this meeting with another type of meeting in the My BBA Journey.</li></ul></li></ul>
        <p>If you have any questions about My BBA Journey, please refer to the specific section of the intranet by <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey">clicking here</a> or speak with your manager or your assigned HRBP.</p>
        <p>Have a great day!</p>
        <p>Human Resources department</p>`,
        outlookFileName: `Invitation - Carrer meeting My Journey BBA - ([EmployeeName])`,
        selectCareerReturnOnDevelopmentActivity: 'select a role / responsibility',
        produceCar: 'Produce CAR document',
        careerStatusLegendExplanation: [
            `You can enter information about the employee’s career.`,
            `The employee has notified their manager that they are ready for the Career meeting.`,
            `The meeting is closed; it is therefore no longer possible to add information.`,
            `The meeting has been held. However, you can continue to add your feedback until the end of the reference year.`,
            'The meeting and approval process was not completed within the required time frame.',
        ],
    },
    documentsRebranding: {
        documentType: 'Document type',
        documentLanguage: 'Document language',
        uploadDocuments: 'Upload documents',
        importAll: 'Import all',
        restartImport: 'Restart import',
        convertDocument: 'Convert document(s)',
        previousStyle: 'Previous style',
        replacementStyle: 'Replacement style',
        zipName: 'documents.zip',
    },
    documentsMFiles: {
        specify: 'Specify if applicable',
        preview: 'Preview (MFile illustrate where fields will be)',
        documentLocation: 'Document Location',
        header: 'Header',
        body: 'Body',
        footer: 'Footer',
        uploadDocuments: 'Upload documents',
        importAll: 'Import all',
        restartImport: 'Restart import',
        modifyDocument: 'Modify document(s)',
        mFilesFieldMapping: 'Adjust MFiles field mapping',
        addField: 'Add a new MFiles field',
        addNewFieldTooltip: 'Click to add a new MFiles field',
        previousMFilesField: 'Previous MFiles Field',
        replacementMFilesField: 'Replacement MFiles Field',
        zipName: 'documents.zip',
        legends: 'Color Legends',
        fromDb: 'Configured field',
        unSet: 'Unset field',
        modified: 'Modified field',
        confirmIgnoreConfiguration: 'Confirm ignored configuration',
        confirmConfigurationDeleteBody: 'Are you sure you want to delete this configuration?',
        confirmConfigurationResetBody: 'Are you sure you want to cancel the modification?',
        confirmConfigurationIgnoreBody: 'Are you sure you want to ignore this configuration?',
        ignoreConfigurationToolTip: 'Ignore this configuration for file processing',
        restoreConfigurationToolTip: 'Restore this configuration for file processing',
        ignoreConfiguration: 'Ignore',
        removeConfiguration: 'Delete this configuration for the MFiles field',
        editConfiguration: 'Edit this configuration for the MFiles field',
        addConfiguration: 'Add this configuration for the MFiles field',
    },
    myTeam: {
        consultant: `List of employees who are consultants within BBA`,
        notFound: `For the search you are doing, we are not getting any results! Please try with other search criteria.`,
        yearReferenceSubtitle: `           
        <p>
        Please select a year from the drop-down menu below to view your current team's results related to that year of
        reference! By default the current year is chosen!
        </p>
        <h4 style="color:#002952">Important</h4>
        <p>
            <u>If there have been any organizational changes during the year!</u> Therefore, you may no longer have access to the records of the
            employees for whom you were responsible. My journey is based on the hierarchical link ('Report-to' section of the employee record in MFiles), to show you the list of employees
            display the list of employees.
        </p>
        <p>
            If you are in charge of finishing the evaluation year of an employee who has changed managers. Please
            contact said manager.
        </p>`,
        warningsDashbord: `Only regular type employees are displayed in the dashboard!`,
        legendExplenation: `The star is to identify employees who are of the `,
        legendExplenation2: `regular `,
        legendExplenation3: `type. So they are neither interns, nor temporary, nor students.`,
        consultantExplenation: `Only consultants who have access to My BBA Journey appear, i.e., those who have a BBA email address.`,
        noEmployee: 'You do no have any employee to manage',
        noNotes: `You have no notes about this employee`,
        lastUpdate: 'Last update',
        nextUpdate: 'Next update',
        left: 'Left',
        completed: 'Completed',
        myTeam: 'My team',
        objective: 'Objective',
        objectives: 'Objectives',
        annualObjectives: 'Annual Objectives',
        targetPercentage: 'Target %',
        jobLevel: 'Job level',
        followUp: 'Follow-up',
        firstFollowUp: 'First Follow-up',
        secondFollowUp: 'Second Follow-up',
        career: 'Career',
        feedback: 'Feedback',
        feedbacks: `For the feedback column the number on the left is the amount of feedback received by the employee and the number on the right is the amount sent.`,
        sentFeedbacks: 'Feedback received | sent',
        overallAssessment: 'Overall Assessment',
        target: 'Target',
        hrLevel: 'HR Level',
        profileOf: "{0}'s profile",
        exitProfile: 'Exit profile',
        viewFollowUps: 'View follow-ups',
        viewObjectives: 'View objectives',
        viewFeedbacks: 'View feedbacks',
        employeeNotes: 'Notes on employee (confidential Managers + HRBP)',
        careers: 'Career',
        viewPersonalNotes: 'View personal notes',
        viewCareer: 'View Career',
        viewOverall: 'View Overall Assessment',
        addNote: 'Add note',
        noNote: 'No existing personal note',
        performanceCriteria: 'Performance criteria',
        author: 'Author',
        newPersonalNote: 'New personal note',
        editPersonalNote: 'Edit personal note',
        deleteNoteTitle: 'Delete note?',
        deleteNoteBody: 'This will permanently delete this personal note.',
        disabledPersonalNote: 'This personal note is currently being synchronized, so it cannot be modified right now',
    },
    covid: {
        isEmployee: 'I am a BBA employee',
        officeVisited: 'Office visited',
        visitDated: 'Visit dated',
        last30Days: 'Last 30 days',
        generalSummary:
            "If you answered YES to either of the above questions you are not permitted to enter our facilities and our client's facilities. If you experience symptoms associated with COVID-19 while in the office, you must return home and contact your public health authority for direction. Please contact your department manager or the HSE department with any questions.",
        labradorSummary:
            "If you have answered NO to the last question or YES to any other question, you are not permitted to enter our facilities and our client's facilities. If you experience symptoms associated with COVID-19 while in the office, you must return home and contact your public health authority for direction. Please contact your department manager or the HSE department with any questions.",
        validInformation: 'I confirm that all the given information are truthful.',
        bbaKeepInformation: 'I authorize BBA to retain this statement for a period of 30 days.',
        goToGuestForm: 'Guest form',
        goToEmployeeForm: 'Employee form',
        goToFormList: 'Form list',
        consultSymptoms: 'Consult symptoms',
        company: 'Entreprise',
        authorized: 'Authorised',
        presences: 'Total presences',
    },
    preferences: {
        feedbackNotifSettingTitle: 'Why the option is disabled?',
        feedbackNotifSettingText:
            'As for BBA, feedback is considered urgent and important. In order to reinforce this type of interaction between employes and administrator we want to force external notification on that topic. Thank you for your understanding',
        emailNotification: 'Notify me of new notifications by email for the following sections :',
        recordPreferences: 'Save your preferences',
    },
    notifications: {
        notification: 'Notifications',
        deleteWarning: `You were unable to clear the notification. Please try again.`,
        markAsSeenWarning: `You did not succeed in marking as seen the notification. Please try again.`,
        loadingError: `We couldn't find the notifications linked to your account. Please refresh the page or press F5`,
    },
    overallAssessment: {
        produceAga: `Generate an AGA document`,
        weightSumWarningTitle: `*** Please note! At this time of year, the calculation of individual performance includes the % of completion of all objectives, including the operational objective, if you are eligible.`,
        performance: `Performance`,
        targetInfo: `If ever the target percentage(%) does not correspond with what the employee must have, please contact Caroline Ménard from the HR team.`,
        revisionTitle: `Request for review forwarded`,
        revisionContent: `A notification has been sent to your manager. You will now be redirected to the home page of this section.`,
        freezeTitle: `Overall assessment completed`,
        freezeMeeting: `You have successfully completed your employee overall assessment meeting. Now make sure that your employee approve at the bottom of the meeting.`,
        chooseYour: `Please select one`,
        chooseExplaination: `Make your selection to display your choice`,
        whyReview: `Why a request for review?`,
        becauseReview: `The review request is to allow comments or files to be added to a global assessment meetsubmitSuccessBodySaveing. By pressing the button a notification will be sent to your 
        will be sent to your manager to reopen the meeting.`,
        revision: `Requesting a review from your manager `,
        revisionManager: `Reactivating the meeting`,
        whyReviewManager: `Why reactivate the meeting?`,
        becauseReviewManager: `Because your employee would like you to reactivate the Overall assessment meeting to add/change content.
         Or, you want to change the content before both parties have approved it.`,
        approbationButtonTosign: `I approve`,
        approbationButtonSigned: `Approved`,
        approbationEmployee: `Approve your overall assessment meeting`,
        approbationManager: `Approve your employee meeting`,
        objectiveType: ['New strategic objective', 'New role objective', 'New position objective'],
        objectifFreezed: 'Here are the objectives you have set with your manager',
        objectiveNotFreezed: 'Here are the objectives you added during the year',
        submitSuccessBody: `Your Overall Assessment meeting was successfully sent to your manager and has been saved.`,
        submitSuccessBodySave: `Your Overall Assessment meeting has been saved. You now will be redirected to the landing page of overall assessment!`,
        submitSuccessBodySaveManager: `Your employee's overall assessment meeting has been saved. You will be redirected to your employee's overall assessment home page!`,
        noOverall: `There is no Overall Assessment meeting, yet!`,
        year: `Evaluation year`,
        newOverall: `New overall assessment meeting`,
        noOverallAssessment: `As of now you don't have any overall assessment`,
        sectionEmployee: 'Employee section',
        sectionManager: 'Manager section',
        rapidAcces:
            'You can quickly see your feedback, follow-up and career meetings by making your selection in the drop-down menus below',
        comment: 'previous comments',
        commentFinal: 'End of the year comment',
        overallAssessment: 'Overall assessment',
        employeeParts: 'Describe your year at BBA',
        managerParts: 'Describe the year of your employee',
        feedbacks: 'Your feedback',
        followUps: 'Your follow-ups',
        career: 'My career',
        appreciation: 'OVERALL ASSESSEMENT of the end of the year is the final step for the perfomance evaluation',
        firstBullet:
            'For all employees, this involves reviewing the past year, your achievements, whether you attained your annual objectives and your overall performance (status of objectives, percentage achieved and relevant comments).',
        secondBullet:
            'IMPORTANT: in the objectives section of the overall assessment, only managers can modify the objectives (description & weight). ALL (employees as well as managers) can put comments of end of year.',
        careerImportant: 'CAREER MEETING:',
        fourthBullet:
            'Please ensure that the Career Meeting is properly documented by both the employee and the manager and that any relevant comments about the current year are included.',
        fifthBullet: 'The manager is responsible for freezing the career meeting for the current year.',
        titleIsEmptyFeedback: `You have no have feedback`,
        titleIsEmptyFollowUp: `You have no follow-up meetings`,
        titleIsEmptyCareer: `You have no career meetings`,
        textIsEmptyFeedback: `Remember, BBA encourages feedback! Do not hesitate to give positive or constructive feedback to your colleagues.`,
        textIsEmptyFollowUp: `Your meetings have not been closed. Please ask your manager to close your follow-ups by pressing the end meeting button. Or you haven't done any follow-up meetings during the year.`,
        textIsEmptyCareer: `Your meeting has not been closed. Please ask your manager to close your career by pressing the end meeting button. Or you haven't had a career meeting during the year.`,
        outlookFileName: `Invitation - Overall assessment meeting My BBA Journey - ([EmployeeName])`,
        overallAssessmentTitle: 'Invitation - Overall assessment My BBA Journey - ([EmployeeName])',
        overallAssessmentDescription: `<p><span style='font-family:"Century Gothic",sans-serif'>Hello,</span></p>        
        <p><span style='font-family:"Century Gothic",sans-serif'>The time has come to review employee contributions over the year and hold the <b>Overall assessment</b> meeting with your employees.</span></p>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Important information about this meeting:</span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>As part of My BBA Journey, the purpose of the <b>Overall assessment</b> meeting is to close out the year.</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>This meeting has two (2) specific purposes:</span></li>
                <ul>
                    <li><span style='font-family:"Century Gothic",sans-serif'>To discuss how annual goals have progressed and reach a conclusion about their final status</span></li>
                    <li><span style='font-family:"Century Gothic",sans-serif'>To review the entire year and highlight the employee’s key points</span></li>
                </ul>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>How: </span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>The employee and manager prepare for the meeting:</span></li>
                <ul>
                    <li><span style='font-family:"Century Gothic",sans-serif'>by documenting and commenting on how objectives progressed (Year-end comments)</span></li>
                    <li><span style='font-family:"Century Gothic",sans-serif'>by concluding  on their objectives, determining their percentage of completion and weight (only managers can modify). </span></li>                       
                    <li><span style='font-family:"Century Gothic",sans-serif'>by entering, in their respective spaces, any relevant information about employee’s annual performance..</span></li>
                </ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>They schedule an <b>Overall assessment</b> meeting and discuss their respective findings at this meeting.</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>After holding the meeting and properly documenting it, the employee and manager sign the <b>Overall assessment module in My BBA Journey</b></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>The manager approves the <b>Overall assessment module in My BBA Journey</b></span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>What: Additional tools</span></p>
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>Employee Annual Objectives</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Feedback</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Follow-up meetings</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>Career meeting</span></li>            
            <li><span style='font-family:"Century Gothic",sans-serif'>All other relevant available tools</span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>Duration: About 30 minutes, depending on discussions. Please refer to the applicable charge code </span><span><a
        href="https://intranet.bba.ca/sites/practical-information/faq-portal/faq/3520/faq_which-time-code-do-i-need-to-use-for-my-bba-journey-meetings-and-engagement-activities"><b><span style='font-family:"Century Gothic",sans-serif'>here</span></b></a></span><b><span style='font-family:"Century Gothic",sans-serif'>.</span></b></p>
        <p><span style='font-family:"Century Gothic",sans-serif'>When: </span></p>        
        <ul>
            <li><span style='font-family:"Century Gothic",sans-serif'>As of mid-December</span></li>           
            <li><span style='font-family:"Century Gothic",sans-serif'>Refer to the dates that are provided annually for My BBA Journey.</span></li>
        </ul>        
        <p><span style='font-family:"Century Gothic",sans-serif'>If you have any questions about My BBA Journey, please refer to the specific section of the intranet by </span><span>
        <a href="https://intranet.bba.ca/sites/talent-development/SitePageModern/2172/my-bba-journey"><b><span style='font-family:"Century Gothic",sans-serif'>clicking here</span></b></a></span>
        <span style='font-family:"Century Gothic",sans-serif'>or speak with your manager or your assigned HRBP.</span></p>
        <p><span style='font-family:"Century Gothic",sans-serif'>Have a great day!</span></p>       
        <p><span style='font-family:"Century Gothic",sans-serif'>Human Resources department</span></p>`,
        warningCareerReviewTitle: `Do you want to review your employee’s Career meeting?`,
        warningCareerReviewBody: `Now that the Overall assessment is closed,
         we strongly recommend that you view your employee’s Career meeting, review the content and close it.`,
        warningCareerReviewButton: `See the Career meeting.`,
        overallStatusLegendExplanation: [
            `You can enter information about the employee’s overall assessment.`,
            `Both parties have signed and the meeting is closed.`,
            ``,
            `One of the signatures is missing.`,
            `The employee has notified their manager that they are ready for the overall assessment meeting.`,
            `The manager has reopened the meeting.`,
            `It is not yet time to hold your overall assessment.`,
            ``,
            `The meeting was closed automatically because the closing deadline has expired. It is therefore no longer possible to add information.`,
        ],
    },
    synergy: {
        create: 'Create',
        save: 'Save',
        employee: 'Employee',
        nameFrench: 'French name',
        nameEnglish: 'English name',
        referenceYearLabel: 'Reference year',
        teamKey: 'Unique key',
        employeeException: {
            referenceYear: 'Reference year',
            groupOriginal: 'Original group',
            groupManual: 'Modified group',
            departmentOrginal: 'Original department',
            departmentManual: 'Modified department',
            businessCategoryOriginal: 'Original business category',
            businessCategoryManual: 'Modified business category',
            originalEligibility: 'Original eligibility',
            manualEligibility: 'Manual eligibility',
            originalQtyMinObjective: 'Original minimum number of objectives',
            manualQtyMinObjective: 'Manual minimum number of objectives',
            targetManual: 'Manual % Bonus Target',
            targetOriginal: 'Original % Bonus Target',
            originalQtyMaxObjective: 'Original maximum number of objectives',
            manualQtyMaxObjective: 'Manual maximum number of objectives',
            originalHrLevel: 'Original HR level',
            manualHrLevel: 'Manual HR level',
            isEligible: 'Is eligible',
            hasThatObjective: 'Is eligible to this objective',
            weightOriginal: 'Original objective weight',
            weightManual: 'Manual objective weight',
            internalNote: 'Internal note',
            deletePart2: 'This action is also going to delete everything related to this employee exception !',
            createYear: `Duplicate data from previous year`,
            duplicate: `Duplicate`,
        },
        referenceYear: {
            calendarYear: 'Calendar year',
            calendarYearError: 'The calendar year should be the same year as the cut off day',
            startDate: 'Start date',
            startDateError: 'The start date must be earlier than the end date',
            endDate: 'End date',
            endDateError: 'The end date must be later than the start date',
            deadline: 'Deadline',
            cutOffDate: 'HR level cut off date',
            openingOfOverall: `Overall assessment kickoff`,
            closingOfOverall: `Overall assessment closure`,
            deletePart2: 'This action is also going to delete everything related to this reference year !',
        },
        businessCategory: {
            deletePart2: 'This action is also going to delete everything related to this business category !',
        },
        region: {
            deletePart2: 'This action is also going to delete everything related to this region !',
            businessCategorie: 'Business category',
        },
        office: {
            deletePart2: 'This action is also going to delete everything related to this office !',
            region: 'Region',
        },
        departement: {
            key: 'Key',
            uniqueKey: 'Unique key',
            deletePart2: 'This action is also going to delete everything related to this departement !',
        },
        manager: {
            deletePart2: 'This action is also going to delete everything related to this manager !',
            originalManagerType: 'Original manager type',
            manualManagerType: 'Manual manager type',
            originalGroupSize: 'Original group size',
            manualGroupSize: 'Manual group size',
            employee: 'Employee',
            synchronizeManagerWarning: 'Attention! This action will update all managers in the list for the selected year!',
            actions: 'Actions',
            hrLevel: 'Hr Level',
            cantSynchronize: 'As the deadline has passed, syncronization is no longer permitted',
            synchronizeAllManagers: 'Synchronize all managers',
            isDeleted: 'Is deleted',
        },
        baseHrLevelFamily: {
            deletePart2: 'This action is also going to delete everything related to this family !',
            uniqueKey: 'Unique key',
            associatedHrLevels: 'Associated HR Levels',
            bottomThreshold: 'Min. Nb. Objectives',
            topThreshold: 'Max Nb. Objectives',
        },
        group: {
            titleFr: 'Title FR',
            titleEn: 'Title EN',
            uniqueKey: 'Unique key',
            groupType: 'Group Type',
            businessCategorie: 'Business category',
            departements: 'Departments',
            office: 'Office',
            region: 'Region',
            or: 'OR',
            noDepartement: 'No associated department',
        },
        groupType: {
            deletePart2: 'This action is also going to delete everything related to this group type !',
        },
        managerTypeGroupSize: {
            deletePart2: 'This action is also going to delete everything related to this configuration !',
            managerType: 'Manager type',
            groupSize: 'Group size',
            bottomThreshold: 'Bottom threshold',
            topThreshold: 'Top threshold',
        },
        objective: {
            titleFr: 'Title FR',
            titleEn: 'Title EN',
            businessCategorie: 'Business category',
            hrLevel: 'HR level',
            weight: 'Weight',
            uniqueIdentifier: 'Unique Identifier',
            noObjective: 'No objective',
            criteria: 'Criteria',
            isTeamLeadConfig: 'Has team lead configuration',
            value: 'Value',
            completion: 'Completion',
            teamLeadCriteria: 'Team Lead Criteria',
            deletePart2: 'This action is also going to delete everything related to this HR level criteria !',
            baseHrLevelFamilies: 'HR Level Family',
            managerType: 'Manager Type',
            groupSize: 'Group size',
        },
        report :{
            reportType: "Report Type",
            generateReport: "Generate"
        }
    },
    hierarchy: {
        manager: 'Manager',
        directReport: 'Direct report',
        directReports: 'Direct reports',
        startDate: `Starting date`,
        endDate: `End date`,
        duration: `Duration (days)`,
        reason: `Reason`,
        reasonError: `This field is mnadatory. You must provide an explanation for this action.`,
        actions: 'Actions'
    },
};

export default en;
